import { Dialog, DialogContent, DialogTitle, Tooltip } from "@mui/material";
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PullToRefresh from 'react-simple-pull-to-refresh';
import { LoadChannelTemplates } from '../../actions';
import { setHeaderCount, setHeaderTitle, setRefreshHandler } from "../../helpers/header.helper";
import { ChannelTemplates, FacebookTemplateModel, MediaModel } from '../../models/templates.models';
import { buttonLabels, emptyLabels, appNote, pageTitles, ActionLabels, ToasterTexts } from "../shared/constants";
import AddTemplateComponent from './add.template.component';
import * as selector from "../../selectors/selectors";
import { AppRoutes } from "../routes/route.path";
import PageHeaderComponent from "../shared/page-header.component";
import { AddTemplateIcon, CancelIcon, ChannelsGridEmptyIcon, EditIcon, FacebookActiveIcon, GoogleBusinessIcon, InstaActiveIcon, LiveChatIcon, TrashIcon, WhatsappActiveIcon } from "../../icon";
import { ChannelType } from "../../models/conversations";
import { ChannelConversationService } from "../../services/channels/ChannelConversationService";
import GridComponentNew from "../shared/grid";
import { ColDef, ICellRendererParams, ValueGetterParams } from "ag-grid-community";
import { customStringComparator } from "../../helpers/custom-comparators";
import { UtilityService } from "../../services/UtilityService";
import { dateComparator } from "../shared/grid/grid.services";
import { MessageTagRenderer } from "../shared/grid/msgTagRendrer";
import { ChannelAccountModel, ChannelAccountStatus } from "../../models/channels/channels.model";
import { ActionsRenderer } from "../shared/grid/actionsRenderer";
import { ToasterType } from "../shared/toaster/toaster.model";
import setToast from "../../helpers/toaster.helper";
import Confirm_Dialog from "../shared/confirm-dialog.component";
import { ChannelUserModel, mapToChannelUser } from "../../models/users.model";
import SelectChannelSideBarComponent from "../channels/select-channel-side-bar-component";
import LivechatValidationPendingIcon from "../../icons/live-chat-validation-pending-icon.svg";
import LivechatDisconnectedIcon from "../../icons/live-chat-disconnected-icon.svg";
import { MenuItemRenderer } from "../shared/grid/actionsMenuItemRendrer";
import NoDataComponent from "../conversations/no-data-component";
import { updateChannelTemplates, updateFaceboolTemplates } from "../../reducers/reducer";
import ConversationCardsHeader from "../conversations/channels-conversation-cards-header";



interface IProps { Media?: MediaModel }


const TemplateComponent = (props: IProps) => {
    const dispatch = useDispatch()
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const Channels: ChannelAccountModel[] = useSelector(selector.Channels)
    const ChannelTemplates: ChannelTemplates[] = useSelector(selector.ChannelTemplates)
    const FacebookTemplates: FacebookTemplateModel[] = useSelector(selector.FacebookTemplates)
    const ActiveChannelsTypes: number[] = useSelector(selector.ActiveChannelsTypes)
    const LoadingChannels: boolean = useSelector(selector.LoadingChannels)

    const initialChannelOptions = [
        { Label: "Facebook", ChannelType: ChannelType.FACEBOOK, hasSubOptions: Channels?.filter(x => x.ChannelType === ChannelType.FACEBOOK).length >= 1, SubOptions: Channels?.filter(x => x.ChannelType === ChannelType.FACEBOOK).map((x, index) => { return ({ Label: x.NickName, Active: false, ID: x.ID }) }), ActiveIcon: FacebookActiveIcon, Active: ActiveChannelsTypes.includes(1), Icon: FacebookActiveIcon, SubOptionsOpen: true },
        { Label: "Instagram", ChannelType: ChannelType.INSTAGRAM, hasSubOptions: Channels?.filter(x => x.ChannelType === ChannelType.INSTAGRAM).length >= 1, SubOptions: Channels?.filter(x => x.ChannelType === ChannelType.INSTAGRAM).map(x => { return ({ Label: x.NickName, Active: false, ID: x.ID }) }), ActiveIcon: InstaActiveIcon, Icon: InstaActiveIcon, Active: (ActiveChannelsTypes.includes(2) && !ActiveChannelsTypes.includes(1)), SubOptionsOpen: true },
        { Label: "Livechat", ChannelType: ChannelType.LIVE_CHAT, hasSubOptions: Channels?.filter(x => x.ChannelType === ChannelType.LIVE_CHAT).length >= 1, SubOptions: Channels?.filter(x => x.ChannelType === ChannelType.LIVE_CHAT).map((x, index) => { return ({ Label: x.NickName, Active: false, ID: x.ID }) }), ActiveIcon: LiveChatIcon, Icon: LiveChatIcon, Active: (ActiveChannelsTypes.includes(4) && !ActiveChannelsTypes.includes(1) && !ActiveChannelsTypes.includes(2)), SubOptionsOpen: true },
        { Label: "Google Business Messages", ChannelType: ChannelType.GOOGLE_BUSINESS, hasSubOptions: Channels?.filter(x => x.ChannelType === ChannelType.GOOGLE_BUSINESS).length >= 1, SubOptions: Channels?.filter(x => x.ChannelType === ChannelType.GOOGLE_BUSINESS).map(x => { return ({ Label: x.NickName, Active: false, ID: x.ID }) }), ActiveIcon: GoogleBusinessIcon, Icon: GoogleBusinessIcon, Active: false, SubOptionsOpen: true },
        { Label: "Whatsapp", ChannelType: ChannelType.WHATSAPP, hasSubOptions: Channels?.filter(x => x.ChannelType === ChannelType.WHATSAPP).length >= 1, SubOptions: Channels?.filter(x => x.ChannelType === ChannelType.WHATSAPP).map(x => { return ({ Label: x.NickName, Active: false, ID: x.ID }) }), ActiveIcon: WhatsappActiveIcon, Icon: WhatsappActiveIcon, Active: (ActiveChannelsTypes.includes(3) && !ActiveChannelsTypes.includes(1) && !ActiveChannelsTypes.includes(2) && !ActiveChannelsTypes.includes(4)), SubOptionsOpen: true }
    ]

    const navigate = useNavigate();
    const location = useLocation();
    const [ShowTemplateForm, setShowTemplateForm] = useState<boolean>(false)
    const [selectedRow, setSelectedRow] = useState(undefined)
    const [gridApi, setGridApi] = useState(null);
    const [columnApi, setcolumnApi] = useState<any>(null)
    const [searchText, setSearchText] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [showConfirmDialog, setShowConfirmDialog] = useState<boolean>(false)
    const [rowData, setRowData] = useState<any[]>();
    const [channelOptions, setChannelOptions] = useState<any[]>(initialChannelOptions);
    const [sidebarWidth, setSidebarWidth] = useState<number>(IsMobileDevice ? 10 : 24);
    const [mobileMenu, setMobileMenu] = useState<boolean>(false)
    const [loadingTemplates, setLoadingTemplates] = useState<boolean>(false)

    const [activeChannel, setActiveChannel] = useState<any>({ Label: "", ChannelType: ChannelType.FACEBOOK, hasSubOptions: Channels?.filter(x => x.ChannelType === ChannelType.FACEBOOK).length >= 1, SubOptions: Channels?.filter(x => x.ChannelType === ChannelType.FACEBOOK).map((x, index) => { return ({ Label: x.NickName, Active: index === 0 ? true : false, ID: x.ID }) }), Icon: FacebookActiveIcon, Active: true, SubOptionsOpen: true });


    const user = mapToChannelUser(JSON.parse(localStorage.getItem("current-user"))) as ChannelUserModel;

    useEffect(() => {
        if (!!ActiveChannelsTypes.length && !!Channels.length && !activeChannel.Label) {
            let initialActiveChannel = initialChannelOptions.find(x => ActiveChannelsTypes.includes(x.ChannelType))
            setChannelOptions(initialChannelOptions.map(x => x.Label === initialActiveChannel.Label ? { Label: initialActiveChannel.Label, ChannelType: initialActiveChannel.ChannelType, hasSubOptions: Channels?.filter(x => x.ChannelType === initialActiveChannel.ChannelType).length >= 1, SubOptions: Channels?.filter(x => x.ChannelType === initialActiveChannel.ChannelType).map((x, index) => { return ({ Label: x.NickName, Active: index === 0 ? true : false, ID: x.ID }) }), Icon: initialActiveChannel.Icon, ActiveIcon: initialActiveChannel.ActiveIcon, Active: true, SubOptionsOpen: true } : x))
            setActiveChannel({ Label: initialActiveChannel.Label, ChannelType: initialActiveChannel.ChannelType, hasSubOptions: Channels?.filter(x => x.ChannelType === initialActiveChannel.ChannelType).length >= 1, SubOptions: Channels?.filter(x => x.ChannelType === initialActiveChannel.ChannelType).map((x, index) => { return ({ Label: x.NickName, Active: index === 0 ? true : false, ID: x.ID }) }), Icon: initialActiveChannel.Icon, ActiveIcon: initialActiveChannel.ActiveIcon, Active: true, SubOptionsOpen: true })
        }
    }, [Channels, ActiveChannelsTypes])

    const onGridReady = (params) => {
        setGridApi(params.api)
        setcolumnApi(params.columnApi)
    }


    const searchTemplate = (e: any) => {
        setSearchText(e.target.value);
        gridApi.setQuickFilter(e.target.value)
    }

    const handleSearch = (value) => {
        setSearchText(value);
        gridApi.setQuickFilter(value)
    }

    const addTemplate = (template?: any) => {
        if (activeChannel.ChannelType === ChannelType.WHATSAPP) {
            navigate(AppRoutes.ADD_WHATSAPP_TEMPLATES_SETUP)
        }
        else {
            setShowTemplateForm(true)
            setSelectedRow(template)
        }
    }

    const closeTemplate = (isConfirm: boolean) => {
        setShowTemplateForm(false)
    };

    useEffect(() => {
        setHeaderTitle(pageTitles.TEMPLATES);
        setRefreshHandler(gridRefresh);
        if (searchText !== "") {
            gridApi.setQuickFilter(searchText);
        }
        setHeaderCount("0 templates")
        return setHeaderTitle
    }, [])

    const gridRefresh = () => {
        dispatch(updateChannelTemplates([]))
        dispatch(updateFaceboolTemplates([]))
        setLoadingTemplates(true)
        LoadChannelTemplates(dispatch, user.OrganizationID)
        if (!!columnApi) {
            columnApi.resetColumnState()
        }

        if (!!gridApi) {
            gridApi.refreshCells({ force: true })
        }
    }

    const pullToRefresh = () => new Promise((resolve) => setTimeout(resolve, 15)).then(() => LoadChannelTemplates(dispatch, user.OrganizationID)
    )

    useEffect(() => {
        setSearchText("")
    }, [location.pathname])


    const ChannelTemplateColoumnDefs: ColDef[] = [
        {
            field: "Title",
            headerName: "Title",
            wrapText: true,
            autoHeight: true,
        },
        {
            field: "ChannelAccountID",
            headerName: "Page Name",
            wrapText: true,
            autoHeight: true,
            hide: activeChannel.ChannelType === ChannelType.LIVE_CHAT,
            valueGetter: (params: ValueGetterParams) => {
                return Channels.find(x => x.ID === params.data?.ChannelAccountID)?.Name
            },

        },
        {
            field: "",
            headerName: "Template Type",
            wrapText: true,
            autoHeight: true,
            hide: activeChannel.ChannelType === ChannelType.LIVE_CHAT,
            valueGetter: (params: ValueGetterParams) => {
                return params.data?.Payload?.template_type === "button" ? "Button" : "Media"
            },
        },
        {
            field: "Message",
            headerName: "Message",
            wrapText: true,
            autoHeight: true,
            hide: activeChannel.ChannelType === ChannelType.FACEBOOK,
            comparator: customStringComparator,
            cellRendererSelector: (params: ICellRendererParams) => {
                if (params.data.Text) {
                    const Message = {
                        component: MessageTagRenderer,
                        params: {
                            Message: params.data.Text
                        }
                    }
                    return Message
                }
                return undefined
            },
        },
        {
            field: "",
            headerName: "Attachment",
            hide: activeChannel.ChannelType === ChannelType.FACEBOOK,
            cellRenderer: (params) => {
                return params.data?.Url && <div className="d-flex align-center">
                    {/* <MediaContainer Mediatype={params.data?.MediaType} Value={params.data?.Url} /> */}
                    <img src={params.data?.Url} className="w-4 h-4" />
                    <span className="ml-1">{params.data?.Filename}</span>
                </div>
            },
            wrapText: true,
            autoHeight: true,
        },
        {
            field: "UpdatedAt",
            headerName: "Last updated",
            valueGetter: (params: ValueGetterParams) => UtilityService.convertDateToDay(params.data.UpdatedAt),
            comparator: (valueA, valueB, nodeA, nodeB) => dateComparator(nodeA.data.UpdatedAt, nodeB.data.UpdatedAt),
            sort: !IsMobileDevice ? 'desc' : null,
            hide: IsMobileDevice,
        },
        {
            field: "Action",
            maxWidth: 40,
            headerName: "",
            pinned: "right",
            lockPinned: true,
            lockPosition: "right",
            cellClass: "ag-cell-actions-style",
            headerClass: "bg-color-secondary",
            cellRenderer: params => <ActionsRenderer MenuData={getMenuActions(params?.data)}{...params} />,
            resizable: false,
            sortable: false,
            hide: IsMobileDevice
        }
    ]

    const getMenuActions = (data) => {
        return [
            {
                Name: ActionLabels.EDIT,
                Icon: EditIcon,
                OnClick: () => addTemplate(data)
            },
            {
                Name: ActionLabels.DELETE,
                Icon: TrashIcon,
                OnClick: () => openConfirmDialog(data)
            }
        ]
    }

    const openConfirmDialog = (template) => {
        setShowConfirmDialog(true)
        setSelectedRow(template);
    };

    const closeConfirmDialog = (isConfim: boolean) => {
        if (!!isConfim) {
            setIsLoading(true);

            ChannelConversationService.deleteChannelTemplate(selectedRow?.ID)
                .then(() => {
                    setIsLoading(false);
                    setToast(ToasterTexts.TEMPLATE_DELETE_SUCCESS.replace('<Name>', selectedRow?.Title), ToasterType.SUCCESS)
                    setSelectedRow([])
                    setShowConfirmDialog(false)
                    LoadChannelTemplates(dispatch, user.OrganizationID)
                }).catch((error: any) => {
                    setIsLoading(false);
                    setSelectedRow([])
                    setShowConfirmDialog(false)
                    setToast(ToasterTexts.SOMETHING_WENT_WRONG_MESSAGE, ToasterType.DANGER)
                })
        } else {
            setSelectedRow([])
            setShowConfirmDialog(false)
        }
    };

    const handleSideBarWidth = (number) => {
        setSidebarWidth(number)
    }

    const handleChannelOptions = (ChannelOptions) => {
        let ActiveChannel = ChannelOptions.find(x => x.Active === true)
        setChannelOptions(ChannelOptions)
        setActiveChannel(ActiveChannel)
    }

    useEffect(() => {
        let ActiveSubOption = activeChannel.SubOptions?.find(x => x.Active === true)
        let data = activeChannel.ChannelType === ChannelType.FACEBOOK ?
            ActiveSubOption ?
                Channels.find(x => x.ID === ActiveSubOption.ID).Status === ChannelAccountStatus.CONNECTED ?
                    FacebookTemplates.filter(x => x.ChannelAccountID === ActiveSubOption.ID) :
                    []
                :
                FacebookTemplates.filter(x => x.ChannelType === activeChannel.ChannelType) : ActiveSubOption ? Channels.find(x => x.ID === ActiveSubOption.ID).Status === ChannelAccountStatus.CONNECTED ?
                    ChannelTemplates.filter(x => x.ChannelAccountID === ActiveSubOption.ID) :
                    [] :
                ChannelTemplates.filter(x => x.ChannelType === activeChannel.ChannelType)
        setRowData(data)
        setLoadingTemplates(false)
    }, [FacebookTemplates, ChannelTemplates])

    useEffect(() => {
        let ActiveSubOption = activeChannel.SubOptions?.find(x => x.Active === true)
        let data = activeChannel.ChannelType === ChannelType.FACEBOOK ?
            ActiveSubOption ?
                Channels.find(x => x.ID === ActiveSubOption.ID).Status === ChannelAccountStatus.CONNECTED ?
                    FacebookTemplates.filter(x => x.ChannelAccountID === ActiveSubOption.ID) :
                    []
                :
                FacebookTemplates.filter(x => x.ChannelType === activeChannel.ChannelType) : ActiveSubOption ? Channels.find(x => x.ID === ActiveSubOption.ID).Status === ChannelAccountStatus.CONNECTED ?
                    ChannelTemplates.filter(x => x.ChannelAccountID === ActiveSubOption.ID) :
                    [] :
                ChannelTemplates.filter(x => x.ChannelType === activeChannel.ChannelType)
        setRowData(data)
    }, [activeChannel])

    useEffect(() => {
        if (!!rowData) {
            setHeaderCount(`${rowData?.filter(x => x.Status != ChannelAccountStatus.DELETED).length} templates`)
            return setHeaderCount
        }
    }, [rowData])

    const handleChange = (e) => {
        let activechan = Channels.find(x => x.NickName === e.target.value)
        setActiveChannel({ Label: activechan.ChannelType === ChannelType.FACEBOOK ? "Facebook" : activechan.ChannelType === ChannelType.LIVE_CHAT ? "Livechat" : activechan.ChannelType === ChannelType.INSTAGRAM ? "Instagram" : "Whatsapp", ChannelType: activechan.ChannelType, hasSubOptions: Channels?.filter(x => x.ChannelType === activechan.ChannelType).length >= 1, SubOptions: Channels?.filter(x => x.ChannelType === activechan.ChannelType).map((x, index) => { return ({ Label: x.NickName, Active: x.ID === activechan.ID, ID: x.ID }) }), Icon: LiveChatIcon, Active: true, SubOptionsOpen: false })

        if (activechan.ChannelType === ChannelType.FACEBOOK) {
            setRowData(FacebookTemplates.filter(x => x.ChannelAccountID === activechan.ID))
        }
        else {
            setRowData(ChannelTemplates.filter(x => x.ChannelAccountID === activechan.ID))
        }
    }

    const handleRowClick = (row) => {
        if (IsMobileDevice) {
            setMobileMenu(true);
            setSelectedRow(row)
        }
    }

    const closeMobileMenu = () => {
        setMobileMenu(false);
    }

    const handlePage = (page) => {
        const initialActiveChannel = channelOptions.find(x => x.Active === true)
        setActiveChannel({ ...activeChannel, SubOptions: activeChannel.SubOptions.map(x => { return { ...x, Active: x.ID === page.ID } }) })
        setChannelOptions(initialChannelOptions.map(x => x.Label === initialActiveChannel.Label ? { Label: initialActiveChannel.Label, ChannelType: initialActiveChannel.ChannelType, hasSubOptions: false, SubOptions: Channels?.filter(x => x.ChannelType === initialActiveChannel.ChannelType).map((x, index) => { return ({ Label: x.NickName, Active: index === 0 ? true : false, ID: x.ID }) }), Icon: initialActiveChannel.Icon, ActiveIcon: initialActiveChannel.ActiveIcon, Active: true, SubOptionsOpen: false } : x))
    }

    return (
        <>
            {IsMobileDevice && ShowTemplateForm ?
                <AddTemplateComponent
                    CloseTemplate={closeTemplate}
                    Template={selectedRow}
                    Show={ShowTemplateForm}
                    SelectedPage={activeChannel.SubOptions.find(x => x.Active)}
                    SelectedChannel={activeChannel.ChannelType} />
                :
                <>
                    {IsMobileDevice
                        ?
                        <>
                            <PullToRefresh isPullable={IsMobileDevice} pullingContent='' onRefresh={pullToRefresh}>
                                <div className=" h-p-100 o-hidden">
                                    <div className="px-1">
                                        <PageHeaderComponent
                                            PlaceHolder={"Find a Template ..."}
                                            HideSearch={true}
                                        />
                                        <ConversationCardsHeader handleSearch={handleSearch} pages={!!activeChannel.SubOptions?.length ? activeChannel.SubOptions : []} activePage={!!activeChannel.SubOptions?.length ? activeChannel.SubOptions?.find(x => x.Active) : ""} handlePage={handlePage} SelectChannel={true} ChannelOptions={channelOptions} handleChannelOptions={handleChannelOptions} HideFilter={true} />
                                    </div>

                                    <GridComponentNew
                                        ColumnDefs={ChannelTemplateColoumnDefs}
                                        RowData={rowData?.filter(x => ActiveChannelsTypes.includes(x.ChannelType))}
                                        OnGridReady={onGridReady}
                                        IsPaginationEnabled={!IsMobileDevice}
                                        EmptyLabel={Channels.find(x => x?.ID === activeChannel.SubOptions.find(x => x.Active)?.ID)?.Status === ChannelAccountStatus.DISCONNECTED ?
                                            (
                                                <div>
                                                    <div className='mb-2'><img src={LivechatDisconnectedIcon} alt="" /></div>
                                                    <span><Link to={AppRoutes.CHANNELS} className="color-primary-link"> {activeChannel.SubOptions.find(x => x.Active)?.Label}</Link> has been disconnected,Connect the channel to view templates.</span>
                                                </div>
                                            )
                                            : Channels.find(x => x?.ID === activeChannel.SubOptions.find(x => x.Active)?.ID)?.Status === ChannelAccountStatus.VALIDATION_PENDING ?
                                                (
                                                    <div>
                                                        <div className='mb-2'><img src={LivechatValidationPendingIcon} alt="" /></div>
                                                        <span><Link to={AppRoutes.CHANNELS} className="color-primary-link"> {activeChannel.SubOptions.find(x => x.Active)?.Label}</Link> validation is pending,Connect the channel to view templates.</span>
                                                    </div>
                                                )
                                                : <div>
                                                    <div className="mt-8"><ChannelsGridEmptyIcon /></div>
                                                    <span className="h5-medium">{emptyLabels.TEMPLATES}</span>
                                                </div>}
                                        LockVisible={IsMobileDevice}
                                        OnGridRowClick={handleRowClick}
                                    />
                                </div>
                            </PullToRefresh>
                            {
                                IsMobileDevice && mobileMenu && selectedRow !== null &&
                                <Dialog
                                    fullWidth
                                    onClose={closeMobileMenu}
                                    aria-labelledby="responsive-dialog-title"
                                    open={mobileMenu}
                                    classes={{ paper: "br-2 dialogue-shadow w-p-70 bg-color-menu-bg" }}
                                >
                                    <DialogTitle className="dialog-header pb-1">
                                        <div className="h1 color-display-title d-flex" id="customized-dialog-title">
                                            {UtilityService.trimMessage(selectedRow?.Title, 18)}
                                            <Tooltip title='Close' placement='bottom'>
                                                <span className="ml-auto">
                                                    <CancelIcon onClick={(e: any) => { e.stopPropagation(); closeMobileMenu() }} />
                                                </span>
                                            </Tooltip>
                                        </div>
                                    </DialogTitle>
                                    <DialogContent className={"o-hidden py-1 px-1 "}>
                                        <MenuItemRenderer MenuData={getMenuActions(selectedRow)} OnClick={closeMobileMenu} />
                                    </DialogContent>
                                </Dialog>
                            }
                        </> :
                        <div className="d-flex flex-direction h-p-100 o-hidden justify-between">
                            <div className='w-p-96 mx-auto'>
                                <PageHeaderComponent
                                    PlaceHolder={"Find a Template ..."}
                                    onSearch={searchTemplate}
                                    Actions={[{
                                        OnClick: () => addTemplate(),
                                        ButtonLabel: buttonLabels.ADD_NEW_TEMPLATE,
                                        Variant: Channels.find(x => x.ID === activeChannel.SubOptions?.find(x => x.Active)?.ID)?.Status === ChannelAccountStatus.CONNECTED ? "primary-btn" : "disabled-btn",
                                        Icon: AddTemplateIcon,
                                    }]} />
                            </div>
                            <div className={`w-p-100 h-p-100 d-flex justify-center align-center  ${IsMobileDevice ? "" : "bg-color-secondary"}`}>
                                <div className="w-p-96 h-p-100 bg-color-side-bar br-3 d-flex o-hidden">
                                    <div className={`min-w-${sidebarWidth} d-flex align-center justify-center h-p-96 my-auto ml-2 select-channel-active-border br-2`}>
                                        <SelectChannelSideBarComponent Options={channelOptions} handleSidebarWidth={handleSideBarWidth} handleOptions={handleChannelOptions} />
                                    </div>
                                    {(Channels.length && channelOptions.find(x => x.Active)?.SubOptions.length && !loadingTemplates) ?
                                        <div className={`${IsMobileDevice ? "w-p-100" : `flex-1`}  h-p-100 channel-side-bar-icon`}>
                                            <GridComponentNew
                                                ColumnDefs={ChannelTemplateColoumnDefs}
                                                RowData={rowData}
                                                OnGridReady={onGridReady}
                                                IsPaginationEnabled={!IsMobileDevice}
                                                EmptyLabel={Channels.find(x => x?.ID === activeChannel.SubOptions.find(x => x.Active)?.ID)?.Status === ChannelAccountStatus.DISCONNECTED ?
                                                    (
                                                        <div>
                                                            <div className='mb-2'><img src={LivechatDisconnectedIcon} alt="" /></div>
                                                            <span><Link to={AppRoutes.CHANNELS} className="color-primary-link"> {activeChannel.SubOptions.find(x => x.Active)?.Label}</Link> has been disconnected,Connect the channel to view templates.</span>
                                                        </div>
                                                    )
                                                    : Channels.find(x => x?.ID === activeChannel.SubOptions.find(x => x.Active)?.ID)?.Status === ChannelAccountStatus.VALIDATION_PENDING ?
                                                        (
                                                            <div>
                                                                <div className='mb-2'><img src={LivechatValidationPendingIcon} alt="" /></div>
                                                                <span><Link to={AppRoutes.CHANNELS} className="color-primary-link"> {activeChannel.SubOptions.find(x => x.Active)?.Label}</Link> validation is pending,Connect the channel to view templates.</span>
                                                            </div>
                                                        )
                                                        : <div>
                                                            <div className="mt-8"><ChannelsGridEmptyIcon /></div>
                                                            <span className="h5-medium">{emptyLabels.TEMPLATES}</span>
                                                        </div>}
                                                LockVisible={IsMobileDevice}
                                            />
                                        </div>
                                        :
                                        <div className={`bg-color-secondary flex-1 h-p-96 my-auto mr-2 select-channel-active-border br-2 min-w-60 ml-2`}>
                                            {(LoadingChannels || loadingTemplates) ?
                                                <NoDataComponent Message={"Please wait while we ready templates for you..."} />
                                                :
                                                <NoDataComponent Message={<div><span className="color-primary-light mx-1 c-pointer w-space" onClick={() => navigate(AppRoutes.ADD_CHANNELS)}>Add a Channel</span> to begin creating message templates. Templates are linked to specific platforms like WhatsApp, Instagram, or Live Chat.</div>} />
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                    {
                        ShowTemplateForm &&
                        <AddTemplateComponent
                            CloseTemplate={closeTemplate}
                            Template={selectedRow}
                            Show={ShowTemplateForm}
                            SelectedPage={activeChannel.SubOptions?.find(x => x.Active)}
                            SelectedChannel={activeChannel.ChannelType}
                        />
                    }
                    {
                        showConfirmDialog &&
                        <Confirm_Dialog
                            ButtonName={buttonLabels.DELETE}
                            onClose={closeConfirmDialog}
                            Show={showConfirmDialog}
                            Text={appNote.TEMPLATE_DELETE}
                            Loading={isLoading}
                            IsMobileDevice={IsMobileDevice}
                        />
                    }
                </>
            }
        </>
    )
}

export default TemplateComponent;
